(function ($, Drupal) {

  // Close messages link
  Drupal.behaviors.closeMessageUhura = {
    attach: function (context, settings) {

      $('.messages').once('closeMessageUhura').each(function () {

        let $el = $(this),
          $close = $el.find('.close');

        $close.on('click', function(evt) {

          $($el).fadeOut();

        });

      });

    }
  };

})(jQuery, Drupal);
